import api from '@shared/services/api';

function normalizeList(raw) {
    if (raw == null) return [];
    if (Array.isArray(raw)) return raw;
    if (Array.isArray(raw.items)) return raw.items;
    if (Array.isArray(raw.content)) return raw.content;
    return [];
}

export const compensationsService = {
    /** GET /hr-contracts-compens-emp/:contractId — employee obligations (first table). */
    getEmployeeCompensations: async (contractId) => {
        const response = await api.get(`/hr-contracts-compens-emp/${contractId}`);
        return normalizeList(response.data);
    },

    /** GET /hr-contracts-compens-emplr/:contractId — employer compensations (second table). */
    getEmployerCompensations: async (contractId) => {
        const response = await api.get(`/hr-contracts-compens-emplr/${contractId}`);
        return normalizeList(response.data);
    },

    /**
     * POST /hr-contracts-compens-emp
     * Body: { contractId, compensationId, amount }
     */
    createEmployeeCompensation: async (body) => {
        const response = await api.post('/hr-contracts-compens-emp', body);
        return response.data;
    },

    /**
     * POST /hr-contracts-compens-emplr
     * Body: { contractId, compensationId, amount, year, totalAmount }
     */
    createEmployerCompensation: async (body) => {
        const response = await api.post('/hr-contracts-compens-emplr', body);
        return response.data;
    },

    /** DELETE /hr-contracts-compens-emp/:id */
    deleteEmployeeCompensation: async (id) => {
        const response = await api.delete(`/hr-contracts-compens-emp/${id}`);
        return response.data;
    },

    /** DELETE /hr-contracts-compens-emplr/:id */
    deleteEmployerCompensation: async (id) => {
        const response = await api.delete(`/hr-contracts-compens-emplr/${id}`);
        return response.data;
    },

    /**
     * GET /hr-compensation-from-emp/list?contractId=… — dropdown options (employee modal).
     * Items: { id, allData }
     */
    getCompensationFromEmpList: async (contractId) => {
        const q =
            contractId != null && contractId !== ''
                ? `?contractId=${encodeURIComponent(String(contractId))}`
                : '';
        const response = await api.get(`/hr-compensation-from-emp/list${q}`);
        return normalizeList(response.data);
    },

    /**
     * GET /hr-compensation-from-emplr/list?contractId=… — dropdown options (employer modal).
     * Items: { id, allData }
     */
    getCompensationFromEmplrList: async (contractId) => {
        const q =
            contractId != null && contractId !== ''
                ? `?contractId=${encodeURIComponent(String(contractId))}`
                : '';
        const response = await api.get(`/hr-compensation-from-emplr/list${q}`);
        return normalizeList(response.data);
    },
};
